var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5V4.5M19 20.5V17.5M5 20.5V16.5M19 13.5V4.5M12 7.5V4.5M12 20.5V11.5",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5C6.10457 16.5 7 15.6046 7 14.5C7 13.3954 6.10457 12.5 5 12.5C3.89543 12.5 3 13.3954 3 14.5C3 15.6046 3.89543 16.5 5 16.5Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5C13.1046 11.5 14 10.6046 14 9.5C14 8.39543 13.1046 7.5 12 7.5C10.8954 7.5 10 8.39543 10 9.5C10 10.6046 10.8954 11.5 12 11.5Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.5C20.1046 17.5 21 16.6046 21 15.5C21 14.3954 20.1046 13.5 19 13.5C17.8954 13.5 17 14.3954 17 15.5C17 16.6046 17.8954 17.5 19 17.5Z",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.b4c94823b3bcffdc261b298d1d92bf67.svg";
export { ForwardRef as ReactComponent };